import clsx from 'clsx';

import { Icon } from '@flintmint/web-shared/components/icon';

import styles from './llm-loading.module.scss';

export const LlmLoading = (props: LlmLoadingProps) => {
  const { active } = props;

  return (
    <div
      data-visible={active}
      data-testid="llm-loading"
      className={clsx(styles.llmLoading, {
        [styles.active]: active,
      })}
    >
      <Icon size={30} type="loading-03" className={styles.spinner} data-testid="loading-icon" />
    </div>
  );
};

interface LlmLoadingProps {
  active: boolean;
}
